import { LogicContext } from '@/logic/main/types';

export const updateFloatingIconContent = async (context: LogicContext) => {
  const floatingIconComponentID = context.floatingIconComponent?.id || '';
  const isIdlePopupVisible = context.idlePopupComponent?.enabled || false;

  if (!floatingIconComponentID) {
    return { updates: [] };
  }

  const updates = [
    {
      type: 'setLayoutProperty',
      data: {
        path: `components.${floatingIconComponentID}.properties`,
        value: {
          isIdlePopupVisible,
        },
      },
    },
  ];
  return { updates };
};
